import { layoutVariants } from '@anm/styles/landingThemeStyles';
import styled from 'styled-components';
export var Wrapper = styled.div.withConfig({
  componentId: "bkrtd3-0"
})(["", ";"], function (_ref) {
  var variant = _ref.variant;
  return layoutVariants[variant];
});